<template>
  <div class="user-wrapper" :class="theme" style="display: flex;align-items: center;">
    <span class="action" @click="toPage('/monitor/map')" title="站点地图">
      <a class="logout_title">
        <a-icon type="environment" />
      </a>
    </span>
    <span class="action" title="大屏展示">
      <span class="logout_title" @click="toPage(dsIndex)">
        <a-icon type="bar-chart"></a-icon>
      </span>
    </span>
    <!-- 永春暂时注释掉预警消息 -->
    <header-notice class="action" v-if="projectCode != 'yongchun'"/>
    <a-dropdown style="max-width: 170px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
      <span class="action action-full ant-dropdown-link user-dropdown-menu">
        <a-avatar class="avatar" size="small" :src="getAvatar()" />
        <span class="siteTitle" v-if="isDesktop()" :title="nickname()">{{ nickname() }}</span>
      </span>
      <a-menu slot="overlay" class="user-dropdown-menu-wrapper" theme="dark">
        <!-- <a-menu-item key="0">
          <router-link :to="{ name: 'account-center' }">
            <a-icon type="user"/>
            <span>个人中心</span>
          </router-link>
        </a-menu-item>
        <a-menu-item key="1">
          <router-link :to="{ name: 'account-settings-base' }">
            <a-icon type="setting"/>
            <span>账户设置</span>
          </router-link>
        </a-menu-item>-->
        <a-menu-item key="1" @click="handleUserParams">
          <a-icon type="setting" />
          <span>个人设置</span>
        </a-menu-item>
        <a-menu-item key="2" @click="updatePassword">
          <a-icon type="setting" />
          <span>密码修改</span>
        </a-menu-item>
        <a-menu-item key="3" @click="handleLogout">
          <a-icon type="logout" />
          <span>退出登录</span>
        </a-menu-item>
        <!--<a-menu-item key="3" @click="updateCurrentDepart">
          <a-icon type="cluster"/>
          <span>切换部门</span>
        </a-menu-item>-->
      </a-menu>
    </a-dropdown>
    <!-- <span class="action">
      <a class="logout_title" href="javascript:;" @click="handleLogout">
        <a-icon type="logout"/>
        <span v-if="isDesktop()">&nbsp;退出登录</span>
      </a>
    </span>-->
    <user-params ref="userParams"></user-params>
    <user-password ref="userPassword"></user-password>
    <!-- <depart-select ref="departSelect" :closable="true" title="部门切换"></depart-select> -->
  </div>
</template>

<script>
import HeaderNotice from './HeaderNotice'
import UserPassword from './UserPassword'
import UserParams from './UserParams'
import DepartSelect from './DepartSelect'
import { mapActions, mapGetters } from 'vuex'
import { mixinDevice } from '@/utils/mixin.js'

export default {
  name: 'UserMenu',
  mixins: [mixinDevice],
  data(){
    return{
      dsIndex:'',
      projectCode:window.localStorage.getItem('projectCode'),
    }
  },
  components: {
    HeaderNotice,
    UserPassword,
    UserParams,
    DepartSelect,
  },
  mounted(){
    this.dsIndex=window.localStorage.getItem('homeUrl') || '/ds/index'
  },
  props: {
    theme: {
      type: String,
      required: false,
      default: 'dark',
    },
  },
  methods: {
    toPage(path) {
      if (path == '/monitor/map') {
        this.$bus.$emit('showSite', 'show', true)
      } else {
        this.$bus.$emit('showSite', 'show', false)
      }
      this.$bus.$emit('showProject', 'show', false)
      this.$router.push(path)
    },
    ...mapActions(['Logout']),
    ...mapGetters(['nickname', 'avatar', 'userInfo']),
    getAvatar() {
      return window._CONFIG['domianURL'] + '/sys/common/file/view' + '/' + this.avatar()
    },
    handleLogout() {
      const that = this

      this.$confirm({
        title: '提示',
        content: '真的要注销登录吗 ?',
        onOk() {
          return that
            .Logout({})
            .then(() => {
              window.location.href = '/'
              //window.location.reload()
            })
            .catch((err) => {
              that.$message.error({
                title: '错误',
                description: err.message,
              })
            })
        },
        onCancel() {},
      })
    },
    updatePassword() {
      let username = this.userInfo().username
      this.$refs.userPassword.show(username)
    },
    handleUserParams() {
      this.$refs.userParams.edit(this.userInfo())
    },
    updateCurrentDepart() {
      this.$refs.departSelect.show()
    },
  },
}
</script>

<style scoped>
.logout_title {
  color: inherit;
  text-decoration: none;
}
.action {
  font-size: 1.3rem;
  color: aqua;
  height: 90% !important;
}
.action:last-child{
	height: 100% !important;
}
.user-dropdown-menu {
  top: -5px;
}
span.siteTitle {
  font-size: 1.1rem !important;
  position: relative;
  top: -2px;
}
</style>